// Auth Types
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const LOGIN_LOADING_ON = 'LOGIN_LOADING_ON'
export const LOGIN_LOADING_OFF = 'LOGIN_LOADING_OFF'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const VERIFY_USER_CNIC = 'VERIFY_USER_CNIC'
export const GET_CURRENT_USER_LOADING_ON = 'GET_CURRENT_USER_LOADING_ON'
export const GET_CURRENT_USER_LOADING_OFF = 'GET_CURRENT_USER_LOADING_OFF'
export const REQUEST_OLD_ENROLL_LOADING = 'REQUEST_OLD_ENROLL_LOADING'

// Quiz Types
export const SET_TIME = "SET_TIME"
export const START_QUIZ = "START_QUIZ"
export const RESUME_QUIZ = "RESUME_QUIZ"
export const MARK_ANSWER = "MARK_ANSWER"
export const FINISH_QUIZ = "FINISH_QUIZ"
export const SUBMIT_QUIZ = "SUBMIT_QUIZ"
export const SELECT_ANSWER = "SELECT_ANSWER"
export const SUBMIT_QUIZ_LOADING = "SUBMIT_QUIZ_LOADING"
export const VERIFY_ENROLLMENT_ID = "VERIFY_ENROLLMENT_ID"
export const VERIFY_ENROLLMENT_ID_LOADING = "VERIFY_ENROLLMENT_ID_LOADING"

// All Students Types
export const GET_ALL_STUDENTS = 'GET_ALL_STUDENTS'
export const GET_ALL_STUDENTS_LOADING_ON = 'GET_ALL_STUDENTS_LOADING_ON'
export const GET_ALL_STUDENTS_LOADING_OFF = 'GET_ALL_STUDENTS_LOADING_OFF'
export const GET_ENROLLMENT_REF_DATA = 'GET_ENROLLMENT_REF_DATA'
export const ENROLLMENT_REF_DATA_LOADING_ON = 'ENROLLMENT_REF_DATA_LOADING_ON'
export const ENROLLMENT_REF_DATA_LOADING_OFF = 'ENROLLMENT_REF_DATA_LOADING_OFF'
export const GET_PAGINATED_STUDENTS = 'GET_PAGINATED_STUDENTS'
export const UPDATE_ENROLLMENT_STATUS = 'UPDATE_ENROLLMENT_STATUS'
export const UPDATE_ENROLLMENT_LOADING_ON = 'UPDATE_ENROLLMENT_LOADING_ON'
export const UPDATE_ENROLLMENT_LOADING_OFF = 'UPDATE_ENROLLMENT_LOADING_OFF'
export const GET_PAYMENT_PROOFS = 'GET_PAYMENT_PROOFS'
export const GET_PAGINATED_PAYMENT_PROOFS = 'GET_PAGINATED_PAYMENT_PROOFS'
export const PAYMENT_PROOFS_LOADING_ON = 'PAYMENT_PROOFS_LOADING_ON'
export const PAYMENT_PROOFS_LOADING_OFF = 'PAYMENT_PROOFS_LOADING_OFF'

// ACCOUNT TYPES
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const CREATE_ACCOUNT_LOADING_ON = 'CREATE_ACCOUNT_LOADING_ON'
export const CREATE_ACCOUNT_LOADING_OFF = 'CREATE_ACCOUNT_LOADING_OFF'

// EXPLORE COURSES TYPES
export const ENROLL_COURSE = 'ENROLL_COURSE'
export const COURSES_LOADING = 'COURSES_LOADING'
export const ENROLL_LOADING = 'ENROLL_LOADING'
export const GET_ALL_COURSES = 'GET_ALL_COURSES'
export const ADD_PAYMENT_PROOF = 'ADD_PAYMENT_PROOF'
export const RESULT_DETAILS = 'RESULT_DETAILS'
export const DOWNLOAD_LOADING = 'DOWNLOAD_LOADING'

// DASHBOARD TYPES
export const DASHBOARD_LOADING = 'DASHBOARD_LOADING'
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA'